export const mockData = {
  // Credibility certifications with enhanced logos
  certifications: [
    {
      name: "Six Sigma Black Belt",
      image: "https://via.placeholder.com/140x90/40E0D0/000000?text=⚫+Six+Sigma+BB",
      icon: "Award",
      description: "DMAIC Methodology Expert"
    },
    {
      name: "ISO 9001:2015 Lead Auditor", 
      image: "https://via.placeholder.com/140x90/40E0D0/000000?text=🏆+ISO+9001:2015",
      icon: "Shield",
      description: "Quality Management Systems"
    },
    {
      name: "ISO 42001 AIMS Lead Auditor",
      image: "https://via.placeholder.com/140x90/40E0D0/000000?text=🤖+ISO+42001",
      icon: "Bot",
      description: "Gen AI & Agentic AI Strategy"
    },
    {
      name: "ISO 27001 ISMS Auditor", 
      image: "https://via.placeholder.com/140x90/40E0D0/000000?text=🔒+ISO+27001",
      icon: "ShieldCheck",
      description: "Information Security"
    },
    {
      name: "Lean Six Sigma Practitioner",
      image: "https://via.placeholder.com/140x90/40E0D0/000000?text=⚡+LEAN+SIGMA",
      icon: "Zap", 
      description: "Process Excellence"
    },
    {
      name: "AI & RPA Certified Expert",
      image: "https://via.placeholder.com/140x90/40E0D0/000000?text=🔧+AI+RPA",
      icon: "Settings",
      description: "Automation & Intelligence"
    }
  ],

  // Case studies with metrics - Real project data
  caseStudies: [
    {
      title: "AI Management System Implementation",
      metric: "40% reduction in manual processes",
      description: "Revolutionary AI-powered quality management system with enterprise-wide impact at HCL Tech",
      client: "HCL Tech - Technology Services",
      savings: "₹8L annual savings"
    },
    {
      title: "Six Sigma Black Belt - Banking Operations",
      metric: "30% efficiency improvement, ₹20L savings",
      description: "DMAIC methodology implementation achieving zero defect process in banking operations",
      client: "Cholamandalam Investment & Finance",
      savings: "₹20L annual savings"
    },
    {
      title: "ISO 9001:2015 QMS Implementation",
      metric: "Zero non-conformities in external audit",
      description: "Complete quality management system deployment with 50+ internal audits conducted",
      client: "Multiple Organizations - Financial Services",
      savings: "100% compliance achieved"
    },
    {
      title: "RPA & AI Automation Suite", 
      metric: "60% manual task reduction, 99.8% accuracy",
      description: "Deployed 10+ RPA bots and 15+ AI systems across cross-functional operations",
      client: "Process Automation Excellence",
      savings: "99.8% process accuracy"
    },
    {
      title: "Lean Process Optimization",
      metric: "25% cycle time reduction, 15% waste elimination", 
      description: "Value stream mapping and lean implementation in market research operations",
      client: "Market Research Operations",
      savings: "35% customer satisfaction improvement"
    },
    {
      title: "US Process Transition Mission",
      metric: "7 processes successfully transitioned offshore",
      description: "Led onsite transition initiative ensuring seamless knowledge transfer and zero post-transition issues",
      client: "First American India - Title Insurance",
      savings: "100% successful migration"
    }
  ],

  // Testimonials - Based on actual experience
  testimonials: [
    {
      quote: "Outstanding Six Sigma implementation that delivered 30% efficiency improvements. The DMAIC methodology was expertly applied with measurable results.",
      author: "Quality Director",
      position: "Banking & Financial Services",
      avatar: "https://via.placeholder.com/60x60/40E0D0/000000?text=QD"
    },
    {
      quote: "Exceptional ISO audit expertise. Achieved zero non-conformities in external audit after comprehensive internal audit preparation.",
      author: "Operations Manager", 
      position: "Technology Services",
      avatar: "https://via.placeholder.com/60x60/40E0D0/000000?text=OM"
    },
    {
      quote: "The AI Management System implementation transformed our operations with 40% reduction in manual processes and unprecedented efficiency.",
      author: "Senior Manager",
      position: "HCL Tech - Enterprise Solutions",
      avatar: "https://via.placeholder.com/60x60/40E0D0/000000?text=SM"
    },
    {
      quote: "Seamless process transition expertise. Successfully moved 7 critical processes offshore with zero post-transition issues.",
      author: "Process Head",
      position: "Title Insurance Operations", 
      avatar: "https://via.placeholder.com/60x60/40E0D0/000000?text=PH"
    },
    {
      quote: "Comprehensive training programs that equipped 500+ employees with quality management skills. Exceptional knowledge transfer.",
      author: "Training Manager",
      position: "Multi-Domain Operations",
      avatar: "https://via.placeholder.com/60x60/40E0D0/000000?text=TM"
    }
  ],

  // Blog insights - Enhanced with latest content
  blogPosts: [
    {
      id: "ai-management-systems-2024",
      title: "AI Management Systems: The Future of Operational Excellence",
      excerpt: "How AI Management Systems (ISO 42001 AIMS) are revolutionizing quality management and driving 40% efficiency improvements across enterprises.",
      date: "December 15, 2024",
      readTime: "8 min read",
      image: "https://via.placeholder.com/400x250/121212/40E0D0?text=AI+Management+2024",
      content: `
        <h2>Introduction</h2>
        <p>Artificial Intelligence Management Systems (AIMS) following ISO 42001 standards are transforming how organizations approach operational excellence. In my recent implementation at HCL Tech, we achieved a remarkable 40% reduction in manual processes while maintaining 99.8% accuracy.</p>
        
        <h3>Key Implementation Strategies</h3>
        <ul>
          <li>Comprehensive AI governance framework</li>
          <li>Risk-based approach to AI deployment</li>
          <li>Continuous monitoring and improvement</li>
          <li>Stakeholder engagement and training</li>
        </ul>
        
        <h3>Measurable Results</h3>
        <p>Our implementation delivered tangible benefits: 40% reduction in manual processes, ₹8L annual savings, and enhanced compliance monitoring capabilities. The key was following DMAIC methodology integrated with AI principles.</p>
        
        <h3>Future Outlook</h3>
        <p>As AI continues to evolve, organizations that implement proper AI Management Systems will gain competitive advantages through improved efficiency, reduced risks, and enhanced decision-making capabilities.</p>
      `
    },
    {
      id: "six-sigma-banking-success",
      title: "Six Sigma Black Belt Success in Banking: 30% Efficiency Gain",
      excerpt: "Real-world case study of DMAIC methodology implementation achieving ₹20L savings and zero-defect processes in banking operations.",
      date: "November 28, 2024", 
      readTime: "6 min read",
      image: "https://via.placeholder.com/400x250/121212/40E0D0?text=Six+Sigma+Banking",
      content: `
        <h2>Project Overview</h2>
        <p>This Six Sigma Black Belt project at Cholamandalam Investment & Finance focused on eliminating defects in loan processing operations using DMAIC methodology.</p>
        
        <h3>Define Phase</h3>
        <p>Problem: High error rates in loan documentation leading to processing delays and customer dissatisfaction.</p>
        
        <h3>Measure Phase</h3>
        <ul>
          <li>Baseline defect rate: 12%</li>
          <li>Average processing time: 5.2 days</li>
          <li>Customer satisfaction: 72%</li>
        </ul>
        
        <h3>Analyze Phase</h3>
        <p>Root cause analysis revealed documentation errors, inadequate training, and lack of standardized processes as primary factors.</p>
        
        <h3>Improve Phase</h3>
        <p>Implemented standardized checklists, enhanced training programs, and automated validation systems.</p>
        
        <h3>Control Phase</h3>
        <p>Results: 30% efficiency improvement, ₹20L annual savings, zero defect process implementation, and 95% improvement in quality metrics.</p>
      `
    },
    {
      id: "iso-audit-best-practices",
      title: "ISO 9001:2015 Audit Excellence: Zero Non-Conformities Guide",
      excerpt: "Proven strategies from 50+ internal audits achieving 100% compliance rate and zero non-conformities in external assessments.",
      date: "November 20, 2024",
      readTime: "7 min read", 
      image: "https://via.placeholder.com/400x250/121212/40E0D0?text=ISO+Excellence",
      content: `
        <h2>Audit Preparation Excellence</h2>
        <p>After conducting 50+ internal audits with zero non-conformities in external assessments, I've developed a systematic approach to ISO 9001:2015 compliance.</p>
        
        <h3>Pre-Audit Checklist</h3>
        <ul>
          <li>Document control system verification</li>
          <li>Process mapping accuracy</li>
          <li>Training record completeness</li>
          <li>Corrective action effectiveness</li>
        </ul>
        
        <h3>Common Pitfalls to Avoid</h3>
        <ol>
          <li>Incomplete document control</li>
          <li>Inadequate training records</li>
          <li>Missing process metrics</li>
          <li>Ineffective corrective actions</li>
        </ol>
        
        <h3>Success Factors</h3>
        <p>The key to successful ISO audits lies in proactive preparation, comprehensive documentation, and continuous improvement mindset. Regular internal audits help identify gaps before external assessments.</p>
      `
    },
    {
      id: "rpa-automation-roi",
      title: "RPA Implementation ROI: 60% Manual Task Reduction Strategy", 
      excerpt: "Step-by-step guide to implementing RPA bots with 99.8% accuracy, based on 45+ successful automation projects across industries.",
      date: "November 10, 2024",
      readTime: "9 min read",
      image: "https://via.placeholder.com/400x250/121212/40E0D0?text=RPA+ROI+2024",
      content: `
        <h2>RPA Implementation Framework</h2>
        <p>Based on 45+ RPA projects, I've developed a comprehensive framework for maximizing ROI while ensuring 99.8% process accuracy.</p>
        
        <h3>Process Selection Criteria</h3>
        <ul>
          <li>High volume, repetitive tasks</li>
          <li>Rule-based decision making</li>
          <li>Structured data inputs</li>
          <li>Clear business rules</li>
        </ul>
        
        <h3>Implementation Phases</h3>
        <ol>
          <li>Process Assessment & Design</li>
          <li>Bot Development & Testing</li>
          <li>User Acceptance Testing</li>
          <li>Production Deployment</li>
          <li>Monitoring & Optimization</li>
        </ol>
        
        <h3>Key Success Metrics</h3>
        <p>Our implementations achieved: 10+ RPA bots deployed, 60% reduction in manual tasks, 15+ AI systems integrated, and 99.8% process accuracy across cross-functional operations.</p>
        
        <h3>Best Practices</h3>
        <p>Success in RPA requires proper change management, comprehensive testing, and continuous monitoring. Focus on processes with clear ROI and minimal exceptions.</p>
      `
    },
    {
      id: "lean-digital-transformation",
      title: "Lean Principles in Digital Era: 25% Cycle Time Reduction",
      excerpt: "Integrating traditional lean methodologies with digital transformation for maximum efficiency and waste elimination in modern operations.",
      date: "October 30, 2024", 
      readTime: "6 min read",
      image: "https://via.placeholder.com/400x250/121212/40E0D0?text=Lean+Digital",
      content: `
        <h2>Digital Lean Transformation</h2>
        <p>Combining lean principles with digital tools creates powerful synergies for operational excellence. Our recent project achieved 25% cycle time reduction and 15% waste elimination.</p>
        
        <h3>Value Stream Mapping 2.0</h3>
        <p>Modern value stream mapping incorporates digital touchpoints, automated processes, and real-time data flows to identify improvement opportunities.</p>
        
        <h3>Digital Waste Categories</h3>
        <ul>
          <li>Data duplication and redundancy</li>
          <li>Manual data entry and transfer</li>
          <li>Excessive approvals and handoffs</li>
          <li>Outdated system integrations</li>
        </ul>
        
        <h3>Implementation Results</h3>
        <p>Key achievements: 25% reduction in cycle time, 15% waste elimination, 35% customer satisfaction improvement, and streamlined value chain processes across market research operations.</p>
        
        <h3>Future of Lean</h3>
        <p>The integration of lean principles with AI, automation, and digital platforms represents the next evolution of operational excellence.</p>
      `
    }
  ],

  // Consultant profile
  consultant: {
    name: "Shunmugavel Subramanian",
    title: "Six Sigma Black Belt & ISO Lead Auditor",
    experience: "21+ years of experience",
    certifications: "Six Sigma Black Belt | ISO 9001:2015 Lead Auditor | AI Management Systems Certified",
    bio: "Driving operational excellence and digital transformation across industries with proven methodologies and innovative solutions. Expert in AI Management Systems, Process Excellence, and Risk Management with measurable results.",
    image: "https://customer-assets.emergentagent.com/job_process-excellence-1/artifacts/curm5bk2_My%20Pic.png",
    achievements: [
      "Six Sigma Black Belt with 2 BB, 5 GB projects",
      "ISO Lead Auditor (9001:2015, 42001 AIMS, 27001 ISMS)",
      "21+ years consulting experience across 9 companies",
      "500+ employees trained with 95% success rate",
      "45+ RPA & AI projects implemented",
      "60+ projects led with measurable ROI"
    ]
  },

  // Contact information
  contact: {
    email: "shunmugavelsubramanian@gmail.com",
    phone: "+91 9962536379",
    whatsapp: "+91 9962536379",
    linkedin: "https://www.linkedin.com/in/shunmugavels",
    calendlyUrl: "https://calendly.com/shansography/strategy-call"
  }
};